import AbstractCheckbox from './AbstractCheckbox';
import forwardRef from '../../utils/forwardRef';
export default forwardRef({
  name: 'AbstractCheckbox',
  ClassComponent: AbstractCheckbox
});